import { createGetPin } from 'app/selectors';
import { pinSlice } from 'features/pin/pinSlice';
import { actionBinder } from 'utils/actionBinder';

import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const usePin = (
    instanceId: string,
): [Record<string, boolean>, (...args: any[]) => void, (...args: any[]) => void, (...args: any[]) => void] => {
    const dispatch = useDispatch();
    const [getPinSelector, pin, unpin, set] = useMemo(
        () => [
            createGetPin(instanceId),
            ...[pinSlice.actions.pin, pinSlice.actions.unpin, pinSlice.actions.set].map(
                (action: any) =>
                    (...args: any[]) => {
                        const actionCreator = actionBinder(action, instanceId);

                        // @ts-ignore
                        return dispatch(actionCreator(...args));
                    },
            ),
        ],
        [dispatch, instanceId],
    );
    const pinnedItems = useSelector(getPinSelector);

    return [pinnedItems, pin, unpin, set];
};
